class ValidationError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
    this.name = this.constructor.name;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
export {
  ValidationError
};
//# sourceMappingURL=ValidationError.js.map
